module.exports = __webpack_public_path__ + "static/img/p2b-2.cda8149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/p2b-2.jpg
// module id = kX54
// module chunks = 1